<template>
  <div>
    <!-- 교환 정보 입력  -->
    <admin-box-item title="교환 정보 입력" :useTab="false">
      <table class="delivery-orderproduct-table">
        <tbody>
        <tr>
          <td>총 주문 상품 금액</td>
          <td>
            <div>교환 전 {{ beforeProductPrice | currency }}</div>
            <div>교환 후 {{ currentProductPrice | currency }}</div>
          </td>
        </tr>
        <tr>
          <td>적립금 사용</td>
          <td>
            <div>초기 사용 금액: {{ order.point | currency }}</div>
          </td>
        </tr>
        <tr>
          <td>쿠폰 할인</td>
          <td>
            <div>초기 할인 금액: {{ order.discount_price | currency }}</div>
          </td>
        </tr>
        <tr>
          <td>초기 배송비</td>
          <td>{{ order.delivery_cost | currency }}</td>
        </tr>
        <tr>
          <td>교환 배송비</td>
          <td>
            <div class="flex align-center">
              <input class="input full has-text-right"
                     style="width:150px"
                     v-model="value.delivery_cost"
                     @input="e => value.delivery_cost = parseInt(e.target.value)"
                     type="number">
              <span style="margin:auto 4px;font-size:0.9rem">원</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>교환 전 총 결제 금액</td>
          <td>{{ beforeTotalPrice | currency }}</td>
        </tr>
        <tr>
          <td>교환 후 총 결제 금액</td>
          <td>{{ currentTotalPrice | currency }}</td>
        </tr>
        <tr style="background-color:#EBEAE4">
          <td>차액</td>
          <td>{{ resultMargin | currency }}</td>
        </tr>
        </tbody>
      </table>

      <div class="column is-full" v-if="resultMargin < 0">
        <span class="flex align-center" style="margin-bottom:12px">
        <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>
        차액만큼 환불이 필요합니다.
        </span>

        <admin-form-item label="환불 방법">
          <div>
            <lp-radio :val.sync="value.refund_method"
                      value_name="value"
                      label_name="label"
                      :data="refundMethodArr"></lp-radio>
          </div>
          <div style="margin-top:6px">
          <span v-if="value.refund_method===0" class="flex align-center">
            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>환불 계좌로 직접 송금하는 방식입니다. 송금 후에는 '환불 관리'에서 환불 처리 상태를 변경해 주시기 바랍니다.</span>
            <span v-else-if="value.refund_method===1" class="flex align-center">
            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>환불 방법을 저장한 뒤, '환불 관리'에서 환불 처리해 주시기 바랍니다.</span>
          </div>
          <div class="columns is-multiline" style="margin-top:0" v-if="value.refund_method===0">
            <div class="column is-3">
             <span class="select">
              <select v-model="value.refund_info.bank"
                      @change="e=> value.refund_info.bank = e.target.value">
                <option value="" disabled selected>환불 계좌 선택</option>
                <option v-for="(bank, idx) in bankArr" :key="`bank-${idx}`">{{ bank.label }}</option>
              </select>
            </span>
            </div>
            <div class="column is-6">
              <input class="input"
                     :value="value.refund_info.account_num"
                     @input="e=> value.refund_info.account_num = e.target.value"
                     placeholder="계좌번호"
                     type="text">
            </div>

            <div class="column is-3">
              <input class="input"
                     :value="value.refund_info.name"
                     @input="e=> value.refund_info.name = e.target.value"
                     placeholder="계좌주"
                     type="text">
            </div>
          </div>
        </admin-form-item>
      </div>
      <div class="column is-full" v-else>
        <span class="flex align-center" style="margin-bottom:12px">
        <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>차액만큼 추가 결제가 필요합니다.
        </span>
        <admin-form-item label="추가 결제 방법">
          <div>
            <lp-radio :val="0"
                      value_name="value"
                      label_name="label"
                      :data="[{label:'현금(입금)', value:0}]"></lp-radio>
            <span class="flex align-center" style="margin-bottom:12px">
            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>입금이 확인되면 교환 배송을 시작해 주세요.
            </span>
            <input class="input"
                   :value="value.deposit_name"
                   @input="e=> value.deposit_name = e.target.value"
                   placeholder="입금자 명"
                   type="text">
          </div>
        </admin-form-item>
      </div>
    </admin-box-item>
    <div class="column is-full">
      <div class="flex justify-center">
        <button class="button is-light" @click="$emit('close')">취소</button>
        <button class="button is-primary" style="margin-left:6px;" @click="saveData">저장하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    components: {LpRadio},
    name: "order-exchange",
    props: {
      order: {
        type: Object,
        required: true
      },
      exchange_order_product: {
        type: Array,
        required: true
      },
      order_product: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        value: {
          order_product: [],
          exchange_order_product: [],
          refund_method: 0,
          is_cancel_point: false,
          point: 0,
          is_cancel_coupon: false,
          coupon_price: 0,
          delivery_cost: 0,
          margin: 0,
          deposit_name: '',
          refund_info: {
            account: '',
            name: '',
            bank: ''
          },
        },
        bankArr: [],
      }
    },
    computed: {
      // 차액
      resultMargin () {
        let total = 0;
        total += this.currentTotalPrice - this.beforeTotalPrice + this.value.delivery_cost;
        if(this.value.is_cancel_point) total -= this.value.point;
        if(this.value.is_cancel_coupon) total -= this.value.coupon_price;
        return total;
      },
      beforeTotalPrice () {
        return this.getTotal(this.order_product, 'total_price');
      },
      beforeProductPrice () {
        return this.getTotal(this.order_product, 'product_price');
      },
      currentTotalPrice () {
        return this.getTotal(this.exchange_order_product, 'op_order_price');
      },
      currentProductPrice () {
        return this.getTotal(this.exchange_order_product, 'op_product_price');
      }
    },
    created () {
      this.getBankList();
    },
    methods: {
      // 환불 방법 목록
      refundMethodArr () {
        let arr = [{label:'현금 환불 (입금)',value:0}];
        if(this.order.pay_type!==2) {
          arr.push({label:'카드 취소', value:1});
        }
        return arr
      },
      getTotal (list, key) {
        let total = 0;
        list.forEach(item => {
          total += item[key];
        })
        return total;
      },
      getBankList() {
        this.$axios.get('public/banks').then(res=>{
          this.bankArr = res.data;
        })
      },
      saveData () {
        let value = this.cloneItem(this.value);
        let id_list = [];
        this.order_product.forEach(item => {
          id_list.push(item.id)
        })
        value.order_product = id_list;

        // 저장하기 전 예외처리
        for(let i=0; i<this.exchange_order_product.length; i++) {
          let op = this.exchange_order_product[i];
          op.quantity = op.op_quantity;
          op.total_price = op.op_order_price;
          op.discount_price = op.op_discount_price;
          op.product_price = op.op_product_price;
          op.delivery_cost = op.op_delivery_price;
        }
        value.exchange_order_product = this.exchange_order_product;
        value.margin = this.resultMargin;
        this.$axios.post(this.getUrl(`delivery/order/${this.$route.query.id}/exchange`), value).then(res => {
          if(res.status===200) {
            this.toast('저장되었습니다')
            this.$emit('confirm')
          }
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    border 1px solid #e0d9d9
    border-bottom-width thin !important
    padding 6px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
    background-color #eee
</style>
